import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Build 1 · Arrendamiento: ¿la entidad lo opera? (producto, proveedor marcado o crédito de arrendamiento).
export function useArrendamientoHabilitado(activo = true) {
  const [habilitado, setHabilitado] = useState(false);
  useEffect(() => {
    if (!activo) return undefined;
    let on = true;
    api.get("/arrendamiento/habilitado")
      .then((r) => { if (on) setHabilitado(!!r.data?.habilitado); })
      .catch(() => { if (on) setHabilitado(false); });
    return () => { on = false; };
  }, [activo]);
  return habilitado;
}
